export default {
    topics: [
        {
            title: ' AddDeliveries ',
            href: 'sm-simulation-AddDeliveries.html',
            attributes: { 'data-id': 'sm-simulation-AddDeliveries' },
            menu: { hasChildren: false },
            tocID: 'sm-simulation-AddDeliveries-d66e3823',
            topics: [],
        },
        {
            title: ' AddOperations ',
            href: 'sm-simulation-AddOperations.html',
            attributes: { 'data-id': 'sm-simulation-AddOperations' },
            menu: { hasChildren: false },
            tocID: 'sm-simulation-AddOperations-d66e3831',
            topics: [],
        },
        {
            title: ' AddPlans ',
            href: 'sm-simulation-AddPlans.html',
            attributes: { 'data-id': 'sm-simulation-AddPlans' },
            menu: { hasChildren: false },
            tocID: 'sm-simulation-AddPlans-d66e3839',
            topics: [],
        },
        {
            title: ' AddPrograms ',
            href: 'sm-simulation-AddPrograms.html',
            attributes: { 'data-id': 'sm-simulation-AddPrograms' },
            menu: { hasChildren: false },
            tocID: 'sm-simulation-AddPrograms-d66e3847',
            topics: [],
        },
        {
            title: ' Schedule ',
            href: 'sm-simulation-Schedule.html',
            attributes: { 'data-id': 'sm-simulation-Schedule' },
            menu: { hasChildren: false },
            tocID: 'sm-simulation-Schedule-d66e3855',
            topics: [],
        },
        {
            title: ' SimulateDeliveries ',
            href: 'sm-simulation-SimulateDeliveries.html',
            attributes: { 'data-id': 'sm-simulation-SimulateDeliveries' },
            menu: { hasChildren: false },
            tocID: 'sm-simulation-SimulateDeliveries-d66e3863',
            topics: [],
        },
        {
            title: ' SimulateOffers ',
            href: 'sm-simulation-SimulateOffers.html',
            attributes: { 'data-id': 'sm-simulation-SimulateOffers' },
            menu: { hasChildren: false },
            tocID: 'sm-simulation-SimulateOffers-d66e3871',
            topics: [],
        },
        {
            title: ' Start ',
            href: 'sm-simulation-Start.html',
            attributes: { 'data-id': 'sm-simulation-Start' },
            menu: { hasChildren: false },
            tocID: 'sm-simulation-Start-d66e3879',
            topics: [],
        },
        {
            title: ' Stop ',
            href: 'sm-simulation-Stop.html',
            attributes: { 'data-id': 'sm-simulation-Stop' },
            menu: { hasChildren: false },
            tocID: 'sm-simulation-Stop-d66e3887',
            topics: [],
        },
    ],
};

